interface Props {
  name: string
  label: string
  checked: boolean
  onSelect: () => void
}

const ActionRadioCard = ({ name, label, checked, onSelect }: Props) => (
  <label
    className={`flex items-center gap-2 border rounded-md px-3 py-2.5 cursor-pointer shadow-sm bg-white ${
      checked ? "border-[#004AF5] bg-[#E2EAFE]" : "border-[#CAD5E2]"
    }`}
  >
    <input
      type="radio"
      name={name}
      checked={checked}
      onChange={onSelect}
    />
    <span className="text-xs text-[#0F172B]">{label}</span>
  </label>
)

export default ActionRadioCard
